import { render, staticRenderFns } from "./AlarmDetail.vue?vue&type=template&id=4e583c7b&scoped=true"
import script from "./AlarmDetail.vue?vue&type=script&lang=js"
export * from "./AlarmDetail.vue?vue&type=script&lang=js"
import style0 from "./AlarmDetail.vue?vue&type=style&index=0&id=4e583c7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e583c7b",
  null
  
)

export default component.exports